import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '../../../../shared/button/button.module';
import { JumbotronModule } from '../../../../shared/jumbotron/jumbotron.module';
import { BankReconciliationSelectorModule } from '../../bank-reconciliation-selector/bank-reconciliation-selector.module';
import { ReconciliationSelectorComponent } from './reconciliation-selector.component';
import { BankAccountSelectorModule } from '../../bank-account-selector/bank-account-selector.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

@NgModule({
    imports: [
        CommonModule,
        BankReconciliationSelectorModule,
        BankAccountSelectorModule,
        JumbotronModule,
        ButtonModule,
        FormsModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
    ],
    declarations: [ReconciliationSelectorComponent],
    exports: [ReconciliationSelectorComponent],
})
export class ReconciliationSelectorModule
{
}
